/**
 * Individual development component
 */

/** Dependencies -------------------------------------------- */

// External

import classNames from 'classnames'

// Internal

import { getPlugin } from '../dictionary'
import { useAppState } from '../state'

import Icon from './icon'
import Tooltip from './tooltip'

import { timestampToDateString } from '../../helpers'

/** Main ---------------------------------------------------- */

const baseClassName = 'development'

export default function Development( props ) {

    // Constants

    const {
        id,
        isFull,
        showAggregate,
        stateAggregate,
        title,
        shortDescription,
        description,
        developmentType,
        developmentLevel,
        created,
        updated,
        placeOfOrigin,
        source,
        sourceLink,
        seeAlso,
        seeAlsoLink,
        ...additionalProps
    } = props

    const plugin = getPlugin()

    const setDevelopment = useAppState( ( state ) => state.setDevelopment )

    const consolidatedClassName = classNames(
        baseClassName,
        { [`is-full`]: isFull },
        { [`is-type-${developmentType.id}`]: developmentType },
        { [`is-level-${developmentLevel.id}`]: developmentLevel },
    )

    // Handlers

    const handleLinkClick = ! isFull
        ? () => { setDevelopment( id ) }
        : null

    return (
        <article className={ consolidatedClassName }>

            { ! isFull && <a className={ `${baseClassName}__link` } onClick={ handleLinkClick }>View this development</a> }

            <header className={ `${baseClassName}__header` }>

                <div className={ `${baseClassName}__meta` }>

                    <span className={ `${baseClassName}__development-type` }>{ developmentType.label }</span>

                    <a
                        href={ plugin.methodologyUrl }
                        target="_blank"
                        className={ `${baseClassName}__development-level` }
                        data-tooltip-id={ `development-${id}-view-methodology` }
                    >
                        { developmentLevel.label }
                    </a>

                    <Tooltip id={ `development-${id}-view-methodology` } place="left">View methodology</Tooltip>
                    
                </div>

                <div className={ `${baseClassName}__title-container` }>
                    <Icon type={ developmentType.iconType } className={ `${baseClassName}__icon` }/>
                    <h1 className={ `${baseClassName}__title` }>                          
                        { title }
                    </h1>
                </div>

            </header>

            <main className={ `${baseClassName}__main` }>

                <p className={ `${baseClassName}__description` }>
                    { showAggregate && <strong className={ `${baseClassName}__aggregate` }>{ stateAggregate.title }: </strong> }
                    { isFull ? description : shortDescription }
                </p>

            </main>

            { isFull &&
                <footer className={ `${baseClassName}__footer` }>
                    <p className={ `${baseClassName}__date-added` }>
                        <strong>Added:</strong> { timestampToDateString( created ) }
                    </p>
                    <p className={ `${baseClassName}__date-updated` }>
                        <strong>Updated:</strong> { timestampToDateString( updated ) }
                    </p>
                    <p className={ `${baseClassName}__place-of-origin` }>
                        <strong>Place of Origin:</strong> { placeOfOrigin }
                    </p>
                    <p className={ `${baseClassName}__source` }>
                        <strong>Source:</strong> <a href={ sourceLink } target="_blank">{ source }</a>
                    </p>

                    { seeAlso &&
                        <p className={ `${baseClassName}__see-also` }>
                            <strong>See Also:</strong> <a href={ seeAlsoLink } target="_blank">{ seeAlso }</a>
                        </p>
                    }

                </footer>
            }

        </article>
    )
}
